import React, { useState } from "react";

import Languages from "../../../../translations";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import CheckBoxTwoToneIcon from "@mui/icons-material/CheckBoxTwoTone";
import DownloadFileButton from "../../../../Components/DownloadFileButton/DownloadFileButton";

const LeopsDecision = ({ supportPlanModel }) => {
  const [expanded, setExpanded] = useState(false);

  if (!supportPlanModel) return null;

  return (
    <Accordion
      className="painikkeet"
      style={{ backgroundColor: "#4377BA" }}
      expanded={expanded}
      onChange={() => setExpanded(!expanded)}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel-decision-content"
      >
        <Typography className="heading">
          {Languages.ChildSpecificEvaluation}
        </Typography>
      </AccordionSummary>
      <div style={{ backgroundColor: "#ffffff" }}>
        <AccordionDetails>
          <Stack
            direction="row"
            spacing={1}
            alignItems="baseline"
            sx={{ mt: 2 }}
          >
            {supportPlanModel.SpecificSupport && (
              <CheckBoxTwoToneIcon sx={{ color: "green", fontSize: 16 }} />
            )}
            <Typography
              color="textSecondary"
              sx={{
                textAlign: "left",
                fontWeight: "medium",
                fontSize: 16,
                color: "#424242",
              }}
            >
              {Languages.SpecificSupportConfirmed}
            </Typography>
            {supportPlanModel.SpecificSupport &&
              supportPlanModel.SpecificSupportAttachmentId && (
                <>
                  <Typography
                    color="textSecondary"
                    sx={{ fontSize: 14, color: "#424242", ml: 1 }}
                  >
                    {supportPlanModel.SpecificSupportAttachmentText}
                  </Typography>
                  <DownloadFileButton
                    FileName={supportPlanModel.SpecificSupportAttachmentText}
                    FileMimeType={
                      supportPlanModel.SpecificSupportAttachmentMimeType
                    }
                    FileId={supportPlanModel.SpecificSupportAttachmentId}
                    file={null}
                    useIconButton={false}
                    useThreeDots={false}
                    useTextButton={true}
                    disabled={false}
                    text={Languages.generalOpen}
                    isImage={false}
                  />
                </>
              )}
          </Stack>
        </AccordionDetails>
      </div>
    </Accordion>
  );
};

export default LeopsDecision;
